import {
  ApolloClient,
  NormalizedCacheObject,
  useMutation,
  useQuery
} from '@apollo/client';
import {
  UpdateNotificationSettingData,
  UpdateNotificationSettingVar,
  UserOptionsData,
  UserOptionsVar
} from '../../notifications/gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../gql';
import { UserOptionAssets } from '../../shared/models/UserOption';

let NotificationApolloClient: ApolloClient<NormalizedCacheObject> = null;

export function useNotificationSettings(userkey: number) {
  if (!NotificationApolloClient) {
    NotificationApolloClient = ApolloClientService.create(
      Config.NOTIFICATION_GQL
    );
  }

  const {
    loading: optionsLoading,
    error: optionsError,
    data: userOptions
  } = useQuery<UserOptionsData, UserOptionsVar>(GraphQL.Query.USER_OPTIONS, {
    client: NotificationApolloClient,
    variables: {
      userkey: userkey
    },
    fetchPolicy: 'network-only'
  });

  const [
    _updateNotificationSetting,
    { loading: updatingSettings, error: updateError, data: updateData }
  ] = useMutation<UpdateNotificationSettingData, UpdateNotificationSettingVar>(
    GraphQL.Mutation.UPDATE_NOTIFICATION_SETTING,
    {
      client: NotificationApolloClient,
      refetchQueries: [
        { query: GraphQL.Query.USER_OPTIONS, variables: { userkey } }
      ],
      awaitRefetchQueries: true
    }
  );

  async function updateNotificationSetting(
    userkey: number,
    userOptionAssets: UserOptionAssets
  ) {
    await _updateNotificationSetting({
      variables: {
        userkey,
        userOptionAssets
      }
    });
  }

  return {
    optionsLoading,
    updatingSettings,
    userOptions: userOptions?.userOptions,
    updateError,
    updateData,
    updateNotificationSetting
  };
}
